import { FLOAMetric, FLOAPerson } from './floa.model';
import { OaPerson, Opportunity, utcDateStringNoTime } from './oa.model';

export enum SortDirection {
    ASC,
    DESC,
    DEFAULT,
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class OpportunitySort {
    /* TODO remove. unused */
    static sortByRankScore(sortorder) {
        return (a: Opportunity, b: Opportunity) => {
            let comp = 0;
            const arank = a.rankScore;
            const brank = b.rankScore;

            if (brank == null) comp = -1;
            else if (arank == null) comp = 1;
            else if (arank < brank) comp = -1;
            else if (arank > brank) comp = 1;

            return sortorder === SortDirection.ASC ? comp * -1 : comp;
        };
    }

    /* TODO remove. unused */
    static sortByOppStatus() {
        return (a: Opportunity, b: Opportunity) => {
            let comp = 0;
            const arank = a.isOppActive;
            const brank = b.isOppActive;

            if (arank == null) comp = -1;
            else if (brank == null) comp = 1;
            else if (arank > brank) comp = -1;
            else if (arank < brank) comp = 1;

            return comp;
        };
    }

    /* TODO remove. unused */
    static sortPerformance() {
        return (a, b) => {
            const evtdate1 = new Date(a.eventDate);
            const evtdate2 = new Date(b.eventDate);

            if (!a.isInitialValues && b.isInitialValues) return -1;
            else if (a.isInitialValues && !b.isInitialValues) return 1;
            else if (evtdate1 > evtdate2) return -1;
            else if (evtdate1 < evtdate2) return 1;
            else return 0;
        };
    }

    static sortByPercentToGoal(sortorder: SortDirection) {
        return (a: Opportunity, b: Opportunity) => {
            let comp = 0;
            if (a == null || a.percentToGoal == null) comp = -1;
            else if (b == null || b.percentToGoal == null) comp = 1;
            else if (a.percentToGoal > b.percentToGoal) comp = -1;
            else if (a.percentToGoal < b.percentToGoal) comp = 1;

            return sortorder === SortDirection.ASC ? comp * -1 : comp;
        };
    }

    static sortByPercentToTarget(sortorder: SortDirection) {
        return (a: Opportunity, b: Opportunity) => {
            let comp = 0;

            if (a.percentToTarget === null && b.percentToTarget !== null)
                return -1;
            else if (b.percentToTarget === null && a.percentToTarget !== null)
                return 1;
            else if (a.percentToTarget < b.percentToTarget) comp = -1;
            else if (a.percentToTarget > b.percentToTarget) comp = 1;

            return sortorder === SortDirection.ASC ? comp * -1 : comp;
        };
    }

    static sortByEstGoalCompletionDate(sortorder: SortDirection) {
        return (a: Opportunity, b: Opportunity) => {
            let comp = 0;
            const n1 = a.estCompletionForGoal
                ? utcDateStringNoTime(a.estCompletionForGoal)
                : null;
            const n2 = b.estCompletionForGoal
                ? utcDateStringNoTime(b.estCompletionForGoal)
                : null;

            if (n1 === null && n2 !== null) return -1;
            else if (n2 === null && n1 !== null) return 1;
            else if (n1 < n2) comp = -1;
            else if (n1 > n2) comp = 1;

            return sortorder === SortDirection.ASC ? comp * -1 : comp;
        };
    }
}

/* TODO remove. unused */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const byOppPercentToGoal = (
    a: Opportunity,
    b: Opportunity,
    sortDirection: SortDirection,
): number => {
    const s1 = a.percentToGoal;
    const s2 = b.percentToGoal;

    let retVal = null;

    if (s1 == null && s2 != null) retVal = 1;
    else if (s2 == null && s1 != null) retVal = -1;
    else if (s1 > s2) {
        retVal = sortDirection === SortDirection.ASC ? 1 : -1;
    } else if (s1 < s2) {
        retVal = sortDirection === SortDirection.ASC ? -1 : 1;
    }
    return retVal;
};

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class OaPeopleSort {
    static sortByRequirements: Function = (
        sortDirection: SortDirection = SortDirection.ASC,
    ) => {
        // sortDirection: true = asc score, desc totalopps, asc name;
        //                false = desc score, asc totalopps, desc name
        return (a: OaPerson, b: OaPerson) => {
            let retVal = 0;

            retVal = byReporting(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byNullScore(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byOaScore(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byTotalOpps(
                a,
                b,
                sortDirection === SortDirection.ASC
                    ? SortDirection.DESC
                    : SortDirection.ASC,
            );
            if (retVal !== null) {
                return retVal;
            }

            retVal = byName(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            return 0;
        };
    };

    static sortByTotalOpportunities: Function = (
        sortDirection: SortDirection,
    ) => {
        // sortDirection: true = asc totalopps, asc name, asc score;
        //                false = desc score, asc totalopps, desc name
        return (a: OaPerson, b: OaPerson) => {
            let retVal = 0;

            retVal = byReporting(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byNullScore(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byTotalOpps(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byOaScore(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            // sort always sort alphabetically
            retVal = byName(
                a,
                b,
                sortDirection === SortDirection.ASC
                    ? SortDirection.DESC
                    : SortDirection.ASC,
            );
            if (retVal !== null) {
                return retVal;
            }

            return 0;
        };
    };

    static sortByPercentToGoalThenRequirements: Function = (
        sortDirection: SortDirection,
    ) => {
        return (a: OaPerson, b: OaPerson) => {
            let retVal = 0;

            retVal = byReporting(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byNullScore(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byPercentToGoal(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byOaScore(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byTotalOpps(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byName(
                a,
                b,
                sortDirection === SortDirection.ASC
                    ? SortDirection.DESC
                    : SortDirection.ASC,
            );
            if (retVal !== null) {
                return retVal;
            }

            return 0;
        };
    };

    static sortByPercentToTargetThenRequirements: Function = (
        sortDirection: SortDirection,
    ) => {
        return (a: OaPerson, b: OaPerson) => {
            let retVal = 0;

            retVal = byReporting(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byNullScore(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byPercentToTarget(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byOaScore(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byTotalOpps(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byName(
                a,
                b,
                sortDirection === SortDirection.ASC
                    ? SortDirection.DESC
                    : SortDirection.ASC,
            );
            if (retVal !== null) {
                return retVal;
            }

            return 0;
        };
    };

    static sortFLOAByRequirements: Function = (
        sortDirection: SortDirection = SortDirection.ASC,
    ) => {
        // sortDirection: true = asc score, desc totalopps, asc name;
        //                false = desc score, asc totalopps, desc name
        return (a: OaPerson, b: OaPerson) => {
            let retVal = 0;

            retVal = byReporting(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byNullScore(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byOaScore(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byExpectedOpps(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byName(
                a,
                b,
                sortDirection === SortDirection.ASC
                    ? SortDirection.DESC
                    : SortDirection.ASC,
            );
            if (retVal !== null) {
                return retVal;
            }

            return 0;
        };
    };

    static sortFLOAMetrics: Function = (
        sortDirection: SortDirection = SortDirection.ASC,
    ) => {
        // sortDirection: true = asc score, desc totalopps, asc name;
        //                false = desc score, asc totalopps, desc name
        return (a: FLOAMetric, b: FLOAMetric) => {
            let retVal = 0;

            retVal = byMetricOpps(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byMetricCoachedOpps(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byMetricName(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            return 0;
        };
    };

    static sortByFLOAScore: Function = (sortDirection: SortDirection) => {
        return (a: FLOAPerson, b: FLOAPerson) => {
            let retVal = 0;

            retVal = byReporting(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byNullScore(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byOaScore(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byName(
                a,
                b,
                sortDirection === SortDirection.ASC
                    ? SortDirection.DESC
                    : SortDirection.ASC,
            );
            if (retVal !== null) {
                return retVal;
            }

            return 0;
        };
    };

    static sortByExpectedOpps: Function = (sortDirection: SortDirection) => {
        return (a: FLOAPerson, b: FLOAPerson) => {
            let retVal = 0;

            retVal = byReporting(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byNullScore(a, b);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byExpectedOpps(a, b, sortDirection);
            if (retVal !== null) {
                return retVal;
            }

            retVal = byName(
                a,
                b,
                sortDirection === SortDirection.ASC
                    ? SortDirection.DESC
                    : SortDirection.ASC,
            );
            if (retVal !== null) {
                return retVal;
            }

            return 0;
        };
    };
}

const byMetricOpps = (a: FLOAMetric, b: FLOAMetric): number => {
    const s1 = a.opportunityCount;
    const s2 = b.opportunityCount;

    let retVal = null;

    if (s1 == null && s2 != null) return -1;
    else if (s2 == null && s1 != null) return 1;
    else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }

    return retVal;
};

const byMetricCoachedOpps = (a: FLOAMetric, b: FLOAMetric): number => {
    const s1 = a.coachedOpportunities;
    const s2 = b.coachedOpportunities;

    let retVal = null;

    if (s1 == null && s2 != null) return -1;
    else if (s2 == null && s1 != null) return 1;
    else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }

    return retVal;
};

const byMetricName = (
    a: FLOAMetric,
    b: FLOAMetric,
    sortDirection: SortDirection,
): number => {
    const n1 = a.metricName;
    const n2 = b.metricName;

    let retVal = null;

    if (!n1) return 1;
    else if (!n2) retVal = -1;
    else if (n1 > n2) {
        retVal = sortDirection === SortDirection.ASC ? 1 : -1;
    } else if (n1 < n2) {
        retVal = sortDirection === SortDirection.ASC ? -1 : 1;
    }

    return retVal;
};

const byExpectedOpps = (
    a: FLOAPerson,
    b: FLOAPerson,
    sortDirection: SortDirection,
): number => {
    const s1 = a.expectedOpportunities;
    const s2 = b.expectedOpportunities;

    let retVal = null;

    if (s1 == null && s2 != null) return -1;
    else if (s2 == null && s1 != null) return 1;
    else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }

    return retVal == null
        ? null
        : sortDirection === SortDirection.ASC
        ? retVal * -1
        : retVal;
};

const byReporting = (
    a: OaPerson | FLOAPerson,
    b: OaPerson | FLOAPerson,
): number => {
    const s1 = a.leftEarly;
    const s2 = b.leftEarly;

    let retVal = null;

    if (s1 == null && s2 != null) return 1;
    else if (s2 == null && s1 != null) return -1;
    else if (s1 < s2) {
        retVal = -1;
    } else if (s1 > s2) {
        retVal = 1;
    }

    return retVal;
};

// always places performers with null scores at the bottom of the list
const byNullScore = (
    a: OaPerson | FLOAPerson,
    b: OaPerson | FLOAPerson,
): number => {
    const s1 = a.oaScore != null;
    const s2 = b.oaScore != null;

    let retVal = null;

    if (s1 > s2) {
        retVal = -1;
    } else if (s1 < s2) {
        retVal = 1;
    }

    return retVal;
};

const byOaScore = (
    a: OaPerson | FLOAPerson,
    b: OaPerson | FLOAPerson,
    sortDirection: SortDirection,
): number => {
    const s1 = a.oaScore;
    const s2 = b.oaScore;

    let retVal = null;

    if (s1 == null && s2 != null) return 1;
    else if (s2 == null && s1 != null) return -1;
    else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }
    return retVal == null
        ? null
        : sortDirection === SortDirection.ASC
        ? retVal * -1
        : retVal;
};

const byTotalOpps = (
    a: OaPerson,
    b: OaPerson,
    sortDirection: SortDirection,
): number => {
    const o1 = a.coached.concat(a.uncoached).concat(a.missed).length;
    const o2 = b.coached.concat(b.uncoached).concat(a.missed).length;

    let retVal = null;

    if (o1 == null && o2 !== null) return 1;
    else if (o2 == null && o1 !== null) return -1;
    else if (o1 < o2) {
        retVal = 1;
    } else if (o1 > o2) {
        retVal = -1;
    }
    return retVal == null
        ? null
        : sortDirection === SortDirection.ASC
        ? retVal * -1
        : retVal;
};

const byName = (
    a: OaPerson | FLOAPerson,
    b: OaPerson | FLOAPerson,
    sortDirection: SortDirection,
): number => {
    const n1 =
        a.firstName && a.lastName
            ? `${a.firstName} ${a.lastName}`.toLowerCase()
            : '';
    const n2 =
        b.firstName && b.lastName
            ? `${b.firstName} ${b.lastName}`.toLowerCase()
            : '';

    let retVal = null;

    if (!n1) return 1;
    else if (!n2) retVal = -1;
    else if (n1 > n2) {
        retVal = sortDirection === SortDirection.ASC ? 1 : -1;
    } else if (n1 < n2) {
        retVal = sortDirection === SortDirection.ASC ? -1 : 1;
    }

    return retVal;
};

const byPercentToGoal = (
    a: OaPerson,
    b: OaPerson,
    sortDirection: SortDirection,
): number => {
    let s1 = a.getTopCoachedGoal(sortDirection);
    let s2 = b.getTopCoachedGoal(sortDirection);

    if (s1 != null) s1 = Math.round(s1);
    if (s2 != null) s2 = Math.round(s2);

    let retVal = null;

    if (s1 == null && s2 != null) return 1;
    else if (s2 == null && s1 != null) return -1;
    else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }
    return retVal == null
        ? null
        : sortDirection === SortDirection.ASC
        ? retVal * -1
        : retVal;
};

const byPercentToTarget = (
    a: OaPerson,
    b: OaPerson,
    sortDirection: SortDirection,
): number => {
    let s1 = a.getTopTarget(sortDirection);
    let s2 = b.getTopTarget(sortDirection);

    if (s1 != null) s1 = Math.round(s1);
    if (s2 != null) s2 = Math.round(s2);

    let retVal = null;

    if (s1 == null && s2 != null) return 1;
    else if (s2 == null && s1 != null) return -1;
    else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }
    return retVal == null
        ? null
        : sortDirection === SortDirection.ASC
        ? retVal * -1
        : retVal;
};
